import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const GeneralLedgerPage = () => {
  const columns = [
    { key: 'accountNumber', label: 'Account #' },
    { key: 'accountName', label: 'Account Name' },
    { key: 'type', label: 'Type' },
    { key: 'category', label: 'Category' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'accountNumber', label: 'Account Number', type: 'text', required: true },
    { key: 'accountName', label: 'Account Name', type: 'text', required: true },
    { key: 'type', label: 'Type', type: 'select', required: true, options: [
      { value: 'Asset', label: 'Asset' },
      { value: 'Liability', label: 'Liability' },
      { value: 'Equity', label: 'Equity' },
      { value: 'Revenue', label: 'Revenue' },
      { value: 'Expense', label: 'Expense' },
    ]},
    { key: 'category', label: 'Category', type: 'select', required: true, options: [
      { value: 'Operating', label: 'Operating' },
      { value: 'Non-Operating', label: 'Non-Operating' },
      { value: 'Capital', label: 'Capital' },
    ]},
    { key: 'description', label: 'Description', type: 'textarea', required: false, fullWidth: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', accountNumber: '1000', accountName: 'Cash', type: 'Asset', category: 'Operating', active: 'Yes' },
    { id: '2', accountNumber: '1100', accountName: 'Accounts Receivable', type: 'Asset', category: 'Operating', active: 'Yes' },
    { id: '3', accountNumber: '2000', accountName: 'Accounts Payable', type: 'Liability', category: 'Operating', active: 'Yes' },
    { id: '4', accountNumber: '3000', accountName: 'Retained Earnings', type: 'Equity', category: 'Capital', active: 'Yes' },
    { id: '5', accountNumber: '4000', accountName: 'Service Revenue - Medicare', type: 'Revenue', category: 'Operating', active: 'Yes' },
    { id: '6', accountNumber: '4100', accountName: 'Service Revenue - Medicaid', type: 'Revenue', category: 'Operating', active: 'Yes' },
    { id: '7', accountNumber: '4200', accountName: 'Service Revenue - Commercial', type: 'Revenue', category: 'Operating', active: 'Yes' },
    { id: '8', accountNumber: '5000', accountName: 'Salaries & Wages', type: 'Expense', category: 'Operating', active: 'Yes' },
    { id: '9', accountNumber: '5100', accountName: 'Employee Benefits', type: 'Expense', category: 'Operating', active: 'Yes' },
    { id: '10', accountNumber: '5200', accountName: 'Office Supplies', type: 'Expense', category: 'Operating', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="General Ledger"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Account"
      formFields={formFields}
      apiEndpoint="/setup/general-ledger"
    />
  );
};

export default GeneralLedgerPage;
